<template>
  <div class="error-logo__wrapper">
    <h1 class="error-logo__text">
      We're Sorry,
    </h1>
    <h1 class="error-logo__text">
      this Page Had a Hard Landing
    </h1>
  </div>
</template>

<script>
export default {
  name: 'AErrorLogo'
}
</script>

<style lang="scss" scoped>
.error-logo__wrapper {
  display: flex;
  flex-direction: column;
}

.error-logo__text {
  display: flex;
  justify-content: flex-start;
}
</style>
